<template>
    <el-dialog
    :title="operate == 'add' || operate == 'addChildrean' || operate == 'threeAddChild'?'新增设备分类':'编辑设备分类'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="500px"
    :before-close="close">
    <div class='dev-type-root'>
      <div class="box">
        <div class="title">
          分类名称
        </div>
        <div class="content">
          <el-input v-model="typeName" style="width: 100%;" placeholder="请输入分类名称"></el-input>
        </div>
      </div>
      <!-- != 'addChildrean' -->
      <div class="box" v-show="operate ">
        <div class="title">
          分类图片
        </div>
        <div class="content">
          <UpLoadImng @getBase64="getBase64" ref="upload" />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { iotApi } from '../../../../../../utils/config'
import { postFun } from '../../../../../../utils/httpFun'
import UpLoadImng from "../../../component/upload-block.vue";
export default {
  components:{
    UpLoadImng
  },
  data() {
    return {
      edit:{},
      operate: 'add',
      dialogVisible:false,
      typeName:'',
      img:'',
      serachCallback:function (){}
    };
  },
  methods:{
    open(operate,item,serachCallback){
      this.operate = operate;
      this.serachCallback = serachCallback;
      
      this.dialogVisible = true;
      if(operate == 'edit' || operate == 'addChildrean' || operate == 'threeAddChild'){
        this.edit = item;
        this.img = this.edit.icon;
        if(operate == 'edit')
          this.typeName = this.edit.classifyName;
          this.$nextTick(()=>{
            this.$refs.upload.setVal(this.edit.icon,'imgSrc');
            this.$refs.upload.setVal(false,'isShow');
        })
        if(operate == 'addChildrean' || operate == 'threeAddChild'){
          this.$nextTick(()=>{
            this.img = null;
            // this.$refs.upload.setVal(this.edit.icon,'imgSrc');
            this.$refs.upload.setVal(null,'imgSrc');
            this.$refs.upload.setVal(true,'isShow');
          })
        }
      }
     
    },
    close(){
      this.$refs.upload.setVal({});
      this.typeName = null;
      this.img = null;
      this.dialogVisible = false;
    },
    getBase64(base64){
      this.img = base64;
    },
    submit(){
      if(!!!this.typeName){
        this.$message.warning('没有输入分类名称')
        return;
      }
      // if(!!!this.img && this.operate != 'addChildrean'){
      //   this.$message.warning('没有选中图片')
      //   return;
      // }

      let param = {
        classifyName:this.typeName,
        icon:this.img,
      }
      if(this.operate == 'add'){

        param.parentId = 0;
        param.parentIds = 0;

        postFun(iotApi.CREATECATEGORY,param,res=>{
          if(res.data){
            this.$message.success("创建成功");
            this.serachCallback('add');
          }else{
            this.$message.warning("创建失败");
          }
          this.close();
        })
      }else if(this.operate == 'edit'){
        param.cId = this.edit.cId;
        postFun(iotApi.UPDATECATEGORY,param,res=>{
          if(res.data){
            this.$message.success("编辑成功");
            console.log('查询',this.serachCallback)
            this.serachCallback('edit');
          }else{
            this.$message.warning("编辑失败");
          }
          this.close();
        })
      }else if(this.operate == 'addChildrean'){
        postFun(iotApi.CREATECATEGORY,{parentId:this.edit.cId,parentIds:"0,"+this.edit.cId,classifyName:this.typeName},res=>{
          if(res.data){
            this.$message.success("创建成功");
            console.log('查询',this.serachCallback)
            this.serachCallback('add');
          }else{
            this.$message.warning("创建失败");
          }
          this.close();
        })
      }else if(this.operate == 'threeAddChild'){
        postFun(iotApi.CREATECATEGORY,{parentId:this.edit.cId.split(',')[1],parentIds:"0,"+this.edit.cId,classifyName:this.typeName,icon:this.img},res=>{
          if(res.data){
            this.$message.success("创建成功");
            console.log('查询',this.serachCallback)
            this.serachCallback(res.data);
          }else{
            this.$message.warning("创建失败");
          }
          this.close();
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dev-type-root{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .box{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .title{
    width: 70px;
  }
  .content{
    width: 263px;
  }
  ::v-deep .el-dialog__header{
    width: 92% !important;
    height: 23px;
    // background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
    margin-bottom: 20px;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
</style>